import { ConfirmDialog } from 'shared/ui/ConfirmDialog';

export function ACHDeleteConfirmDialog({
  open,
  onClose,
  onConfirm,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <ConfirmDialog
      open={open}
      title="Delete ACH Payment Info?"
      onClose={onClose}
      confirmButtonProps={{
        children: 'Delete',
        variant: 'critical',
        onClick: onConfirm,
      }}
    >
      Shippers will not be able to see ACH Payment Info.
    </ConfirmDialog>
  );
}
